module.exports = __webpack_public_path__ + "static/media/msl_tactical_4-3.b36360a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/msl_tactical_4-3.jpg
// module id = 78
// module chunks = 0